import { useRouter } from "next/router";
import * as ESG from "./Esg-guide-styles";
import Image from "next/image";
import { H1Font, H1FontBottom, H2Font } from "./Esg-guide-styles";
import Link from "next/link";

const EsgGuide = () => {
  const router = useRouter();

  return (
    <>
      <ESG.Container>
        <ESG.HeadWrapper>
          <ESG.CommonTitle>
            <ESG.H1Font>ESG자료실</ESG.H1Font>
            <ESG.CommonUnderBar />
          </ESG.CommonTitle>
          <p>
            ‘지속가능성’이 기업에 대한 새로운 투자 기준이 되면서 ESG 경영전략이
            세계적 관심을 받고 있습니다.
            <br />
            ESG란 기업의 비재무적 요소인
            <span>환경(Environment), 사회(Social), 지배구조(Governance)</span>를
            뜻하며
            <br />
            장기적인 관점에서 친환경 및 사회적 책임경영과 투명경영을 통해
            지속가능한 발전을 추구하는 것이 바로 ESG 경영입니다.
          </p>
        </ESG.HeadWrapper>
        <ESG.BodyWrapper>
          <ESG.ImgWrapper>
            <Image
              src="/assets/imgs/page/esg/esgIcons_plus_text.png"
              alt="ESG의 구성 요소: 환경, 사회, 지배구조"
              width={800}
              height={400}
            />
          </ESG.ImgWrapper>
          <ESG.DescWrapper>
            <h4>
              칼렛스토어의 ESG자료실을 통해 기업의 실무자가 반드시 알아야 하는
              ESG 관련 새로운 <span>환경 정책</span>과
              <span> 포장재 트렌드</span>, <span>실제 적용 사례</span> 등을
              소개해드립니다.
            </h4>
          </ESG.DescWrapper>
          <ESG.CardWrapper>
            <article>
              <ESG.CardRow>
                <img
                  src="/assets/imgs/page/esg/esg_card_1.png"
                  alt="ESG 환경뉴스 이미지"
                />
                <div>
                  <ESG.H1FontBottom>ESG 환경뉴스</ESG.H1FontBottom>
                  <p>
                    기업 내 ESG 정책의 방향성을 정하고 빠르게 대응하는데 가장
                    기본 정보인 환경 정책과 관련 뉴스를 전해드립니다.
                  </p>
                  <Link href="/esg-guide/news/">ESG 환경뉴스 보러가기</Link>
                </div>
              </ESG.CardRow>
              <ESG.CardRow>
                <img
                  src="https://file.caretbio.com/caretbio/뉴스레터_이미지.png"
                  alt="뉴스레터 이미지"
                />
                <div>
                  <ESG.H1FontBottom>ESG 뉴스레터</ESG.H1FontBottom>
                  <p>
                    최신 환경 정책과 뉴스, 신제품 출시 소식을 가장 먼저
                    전해드립니다.
                  </p>
                  <Link href="/esg-guide/letter/">ESG 뉴스레터 보러가기</Link>
                </div>
              </ESG.CardRow>
              <ESG.CardRow>
                <img
                  src="/assets/imgs/page/esg/esg_card_2.png"
                  alt="소재와 포장재 이미지"
                />
                <div>
                  <ESG.H1FontBottom>소재와 포장재</ESG.H1FontBottom>
                  <p>
                    다양한 포장재의 소재와 종류를 더욱 알기 쉽게 설명해드립니다.
                  </p>
                  <Link href="/esg-guide/blog/package">
                    소재와 포장재 알아보기
                  </Link>
                </div>
              </ESG.CardRow>
              <ESG.CardRow>
                <img
                  src="/assets/imgs/page/esg/esg_card_3.png"
                  alt="제작사례 포장재 이미지"
                />
                <div>
                  <h2>제작사례 & 포장재리뷰</h2>
                  <p>제작사례 & 포장재리뷰</p>
                  <Link href="/esg-guide/blog/make">사례 & 리뷰 보러가기</Link>
                </div>
              </ESG.CardRow>
            </article>
          </ESG.CardWrapper>
        </ESG.BodyWrapper>
      </ESG.Container>
    </>
  );
};
export default EsgGuide;
